import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker so the app is installable on iOS/Android.
// Only in production builds — in dev, hot-reload + SW caching can fight each
// other and serve stale chunks.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      // Non-fatal: app still works without offline shell.
      console.warn('[SW] registration failed', err);
    });
  });
}
